import React, { useState,useLayoutEffect } from 'react';
// import './Checkout.css';
import { PayPalButtons, usePayPalScriptReducer,PayPalScriptProvider } from "@paypal/react-paypal-js";
import PubSub from 'pubsub-js';
import serverInfo from '../../config';
import userInfo from '../../userInfo';
const Paypal = (props) => {
    // const [{ options, isPending }, dispatch] = usePayPalScriptReducer();
    // const [grandTotal, setGrandTotal] = useState(userInfo.grandTotal);
    // const staticTotal = userInfo.grandTotal
    // const onCurrencyChange = ({ target: { value } }) => {
    //     setCurrency(value);
        
    // }
    // useLayoutEffect(()=>{
        
    //     const submitToken = PubSub.subscribe('currency',(_,data)=>{
    //         setCurrency(data)
    //         dispatch({
    //             type: "resetOptions",
    //             value: {
    //                 ...options,
    //                 currency: "CAD",
    //             },
    //         });
    //     })
    //     const grandTotalToken = PubSub.subscribe('grandTotal',(_,data)=>{
    //         setGrandTotal(data)
            
    //     })
    //     return()=>{
    //       PubSub.unsubscribe(submitToken)
    //       PubSub.unsubscribe(grandTotalToken)
    //     }
    // })
    const onCreateOrder = (data,actions) => {
        // console.log(userInfo.grandTotal)
        return actions.order.create({
            purchase_units: [
                {
                    amount: {
                        value: userInfo.grandTotal.toFixed(2),
                    },
                },
            ],
        });
    }

    const onApproveOrder = (data,actions) => {
        return actions.order.capture().then((details) => {
            // const name = details.payer.name.given_name;
            // alert(`Transaction completed by ${name}`);
            // console.log('Paypal',details,data)
            PubSub.publish('nonce',{result:true,nonce:data.paymentID})
        });
    }
    // console.log('paypal',grandTotal)
    return (
        <div className="payapl-checkout" style={{width:'100%'}}>
                <PayPalButtons 
                    style={{ layout: "vertical" }}
                    createOrder={(data, actions) => onCreateOrder(data, actions)}
                    onApprove={(data, actions) => onApproveOrder(data, actions)}
                    disabled={userInfo.grandTotal<=0 || !userInfo.addressValidation ? true:false}
                />

        </div>
    );
}

export default Paypal;